export default {
    page_title: "Sales",
    confirm_delete: {
        title: "Delete sales",
        body_singular: "Deleting the sale from the database is an irreversible action.",
        body_plural: "Deleting the sales from the database is an irreversible action.",
        warning: "This exclusion is permanent.",
        inconsistency_singular: "Deleting the sale may cause inconsistencies in Kevi reports, which will no longer reflect the same numbers as the ERP.",
        inconsistency_plural: "Deleting the sales may cause inconsistencies in Kevi reports, which will no longer reflect the same numbers as the ERP.",
        instruction: "To confirm, type the phrase below:",
        phrase_singular: "DELETE {0} SALE PERMANENTLY",
        phrase_plural: "DELETE {0} SALES PERMANENTLY",
        button: "Delete",
    },
    more_actions: "More actions",
    remove_all: "Remove all",
    export: "Export",
    table: {
        id: "ID",
        date: "Date",
        status: "Status",
        value: "Value",
        client: "Client",
        phone: "Phone",
        email: "Email",
    },
    filters: {
        client_segment: "Client segment",
        order_status: "Order Status",
    },
    export_headers: {
        id: "Id",
        date: "Date",
        status: "Status",
        value: "Value",
        client: "Client",
        phone: "Phone",
        email: "Email",
        external_id: "External Id",
    },
    deleted_success: "Orders deleted",
    select_all: "Select all",
    unselect_all: "Unselect all",
    selection: {
        count: "{$0} selected",
        export: "Export selected",
        remove: "Remove selected",
    },
    export_selected_success: "{$0} order{$1} exported",
    delete_selected_success: "{$0} order{$1} deleted",
};
